import api from './api';

export default class PessoaFisicaService {
  constructor() {
    throw 'Não é possível instanciar PessoaFisicaService';
  }

  static async obtemAutenticada() {
    const endpoint = mergeEndpoint('autenticada');
    return await api.get(endpoint);
  }

}

const mergeEndpoint = value => {
  return `pessoas-fisicas/${value || ''}`;
};



// WEBPACK FOOTER //
// ./src/services/pessoaFisicaService.js